import type { Event, EventHint } from "@sentry/core";

// Must match every message carrying code 40102: the two ably-js raises locally
// (Auth._ensureValidAuthCredentials, Auth._uncheckedSetClientId) plus the one Ably's server returns
// when a renewal changes identity on a live connection. A wording change on either side silently
// disables this fingerprint.
const ABLY_CLIENT_ID_MISMATCH_PHRASES = [
  "Mismatch between clientId in token",
  "Unexpected clientId mismatch",
  "mismatched clientId for existing connection",
] as const;

export function fingerprintAblyClientIdMismatch<T extends Event>(event: T, _hint: EventHint): T {
  try {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (!exceptionValue || !ABLY_CLIENT_ID_MISMATCH_PHRASES.some((phrase) => exceptionValue.includes(phrase))) {
      return event;
    }

    event.fingerprint = ["ably-client-id-mismatch"];
  } catch {
    // Don't break Sentry error reporting if fingerprinting fails
  }

  return event;
}
